import { useOverlayContext } from 'seagull';
import { GoogleMapsProvider, loadGoogleMaps } from "../../components/AddressAutocomplete";
import { SecureLoginModal } from "../../components/SecureLoginModal/SecureLoginModal";
import { useQboInVob } from "../../components/VendorOnboardingModal/useQboInVob";
import VendorOnboardingModal from "../../components/VendorOnboardingModal/VendorOnboardingModal";
import { useEventReporter } from "../../event-reporter";
import { useFeatureFlags } from "../useFeatureFlags";
import { useStore, useStoreActions } from "../../store/store-context";

// Exported handler function that can be used directly when feature flag is enabled
import { jsx as _jsx } from "react/jsx-runtime";
export const handleCreateVendorAccountApprove = async (userInfo, api, logBI, reportToHeap, reportToHubspot) => {
  logBI(18101);
  reportToHubspot('create_vendor_account_approve_v4');
  reportToHeap('top-bar', 'click', 'client-create-vendor-account-approve');
  if (!(userInfo !== null && userInfo !== void 0 && userInfo.hasApprovedTermsOfService())) {
    const userId = userInfo === null || userInfo === void 0 ? void 0 : userInfo.id();
    if (userId) {
      await api.auth.approveTos(userId);
    }
  }
};
export const useCreateVendorAccount = onClick => {
  const userInfo = useStore(state => state.userInfo);
  const {
    setWorksAt,
    api,
    logBI
  } = useStoreActions();
  const {
    reportToHeap,
    reportToHubspot
  } = useEventReporter();
  const overlayContext = useOverlayContext();
  const {
    SET_IDENTITY_ONLY_TOKEN_FE
  } = useFeatureFlags();
  const showQboStep = useQboInVob();
  const onCreateVendorAccount = async () => {
    onClick === null || onClick === void 0 || onClick();
    reportToHubspot('create_vendor_account_clicked_v2');
    reportToHeap('top-bar', 'click', 'client-create-vendor-account-topbar');
    let hasIdentity = !!(userInfo !== null && userInfo !== void 0 && userInfo.hasIdentity());
    if (!hasIdentity && !SET_IDENTITY_ONLY_TOKEN_FE) {
      hasIdentity = await overlayContext.showModal({
        closeOnClickOutside: true,
        closeOnEscapeKey: true,
        content: _ref => {
          let {
            dismissModal
          } = _ref;
          return /*#__PURE__*/_jsx(SecureLoginModal, {
            dismissModal: dismissModal
          });
        }
      });
    }
    if (hasIdentity || SET_IDENTITY_ONLY_TOKEN_FE) {
      await handleCreateVendorAccountApprove(userInfo, api, logBI, reportToHeap, reportToHubspot);
      setWorksAt();
      await overlayContext.showModal({
        content: _ref2 => {
          let {
            dismissModal
          } = _ref2;
          return /*#__PURE__*/_jsx(GoogleMapsProvider, {
            loadGoogleMaps: loadGoogleMaps,
            children: /*#__PURE__*/_jsx(VendorOnboardingModal, {
              dismissModal: dismissModal,
              showQboStep: !!showQboStep
            })
          });
        },
        closeOnClickOutside: false,
        shouldBlurBackground: true
      });
    } else {
      reportToHubspot('create_vendor_account_canceled_v3');
    }
  };
  return onCreateVendorAccount;
};